var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1091_5817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0047 5.28516C6.71639 5.28516 1.25293 9.63484 1.25293 15.0034C1.25293 20.372 6.71288 24.7182 15.0047 24.7182C23.2965 24.7182 28.7529 20.365 28.7529 15.0034C28.7529 9.64187 23.2895 5.28516 15.0047 5.28516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4651 18.6327C19.8262 18.2216 27.7983 16.5808 26.8145 12.0344C26.4631 10.4006 24.7837 8.60522 22.247 7.35793C19.9521 6.37194 17.4751 5.88108 14.9776 5.91741C7.28658 5.91741 1.93555 9.98602 1.93555 15.0033C1.93555 18.4957 4.53201 21.5278 8.70953 23.0456C9.58439 20.7127 13.1119 19.3846 17.4651 18.6327Z",
    fill: "#007DC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0053 20.242C11.5515 20.6742 9.97047 21.7879 8.95508 23.1406C10.8886 23.7831 12.9152 24.1013 14.9526 24.0822C22.6471 24.0822 27.9981 20.0171 27.9981 15.0034C27.9981 14.5637 27.9569 14.1249 27.8752 13.6929C27.6327 19.5815 18.7928 19.7712 15.0053 20.242Z",
    fill: "url(#paint0_linear_1091_5817)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.54276 10.2603H4.96387L4.99197 10.334C5.09447 10.7366 5.12891 11.1534 5.09386 11.5673C5.09386 11.6727 5.09386 17.5402 5.09386 17.5402H5.14305C5.14305 17.5402 6.32007 17.5823 7.4233 17.5823C9.72815 17.5823 11.2881 16.0224 11.2881 13.6964C11.2741 11.6024 9.80895 10.2603 7.54276 10.2603ZM6.19709 10.9102C6.34466 10.9102 6.80141 10.8646 7.12816 10.8646C9.09922 10.8646 10.0162 11.8202 10.0162 13.8686C10.0162 15.9767 9.20112 17.0307 7.52519 17.0307C6.29547 17.0307 6.19709 16.971 6.19709 16.2437V10.9102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1995 17.4732C18.1608 17.0445 18.1432 16.7705 18.1432 16.507V13.9597H16.9206L16.9592 14.0405C17.0567 14.2884 17.0987 14.5547 17.0822 14.8205C17.0822 14.8381 17.0822 16.5773 17.04 17.0024C16.7285 17.0707 16.4104 17.1049 16.0914 17.1043C14.1449 17.1043 13.1576 15.987 13.1576 13.7876C13.1576 12.1081 14.2679 10.8538 15.8595 10.7378C16.6282 10.6578 17.3982 10.8767 18.0097 11.3492L18.0976 11.4265V10.397H18.0554C17.5032 10.2776 16.9408 10.2105 16.376 10.1968C13.5652 10.1968 11.9033 11.6689 11.9033 14.1389C11.9033 16.767 13.9447 17.7051 15.856 17.7051C16.6251 17.7075 17.3933 17.6512 18.1538 17.5364H18.203L18.1995 17.4732Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.573 13.5348C22.9579 13.442 23.3012 13.2245 23.5496 12.9164C23.7981 12.6082 23.9377 12.2265 23.9468 11.8308C23.9468 10.847 23.0579 10.2603 21.5717 10.2603H19.3652V10.3235C19.4212 10.6412 19.4436 10.9638 19.432 11.2862V17.5859H19.4847C19.4847 17.5859 20.3525 17.5683 21.4171 17.5683C23.2722 17.5683 24.3368 16.7637 24.3368 15.3583C24.3509 14.4905 23.6306 13.7632 22.573 13.5348ZM20.5458 13.8862H21.115C22.429 13.8862 23.0965 14.4026 23.0965 15.4216C23.0965 16.4405 22.5239 17.0167 21.3398 17.0167C20.7706 17.0167 20.5458 16.8094 20.5458 16.2788V13.8862ZM20.5458 10.8259H21.266C22.4009 10.8259 22.8857 11.1773 22.8857 11.9748C22.8857 12.8883 22.292 13.317 21.0131 13.317H20.5423L20.5458 10.8259Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1091_5817",
    x1: 8.64238,
    y1: 18.8858,
    x2: 28.1562,
    y2: 18.8858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#007DC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#0083CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#00B49D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72BF44"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1091_5817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.5,
    height: 19.4295,
    fill: "white",
    transform: "translate(1.25 5.28516)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg30);
export default __webpack_public_path__ + "static/media/대구-30.2360283318ff46f76e650ae79adfef30.svg";
export { ForwardRef as ReactComponent };